"use strict";
// Stremio Plus: controls of the native Picture-in-Picture window (Windows shell).
// The player chrome is hidden there; hovering shows play/pause and "back to the window".
// Dragging the video moves the window, double-clicking it leaves Picture-in-Picture.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var components_1 = require("stremio/components");
var PipOverlay_less_1 = __importDefault(require("./PipOverlay.less"));
var PipOverlay = function (_a) {
    var paused = _a.paused, onTogglePaused = _a.onTogglePaused, onExit = _a.onExit, onStartDrag = _a.onStartDrag;
    var t = (0, react_i18next_1.useTranslation)().t;
    var onMouseDown = (0, react_1.useCallback)(function (event) {
        if (event.button === 0 && event.target === event.currentTarget)
            onStartDrag();
    }, [onStartDrag]);
    return (react_1.default.createElement("div", { className: PipOverlay_less_1.default['pip-overlay'], onMouseDown: onMouseDown, onDoubleClick: onExit },
        react_1.default.createElement(components_1.Button, { className: PipOverlay_less_1.default['exit-button'], title: t('PLAYER_PICTURE_IN_PICTURE_EXIT'), tabIndex: -1, onClick: onExit },
            react_1.default.createElement(react_2.default, { className: PipOverlay_less_1.default['icon'], name: 'maximize' })),
        react_1.default.createElement(components_1.Button, { className: PipOverlay_less_1.default['play-button'], title: paused ? t('PLAYER_PLAY') : t('PLAYER_PAUSE'), tabIndex: -1, onClick: onTogglePaused },
            react_1.default.createElement(react_2.default, { className: PipOverlay_less_1.default['icon'], name: paused ? 'play' : 'pause' }))));
};
exports.default = PipOverlay;
